export class FilterDataMonitoredCases {
  page_size: number = 25;
  page: number = 0;
  code: string = '';

  toObject(): {
    [param: string]: string | number | boolean | (string | number | boolean)[];
  } {
    if (this.code.trim() !== '') {
      return {
        page_size: this.page_size,
        page: this.page + 1, // O componente trata a primeira página como 0, mas o Django como 1
        code: this.code,
      };
    } else {
      return {
        page_size: this.page_size,
        page: this.page + 1, // O componente trata a primeira página como 0, mas o Django como 1
      };
    }
  }
}
